// OfferとOfferHistoryで共有される表示ロジック
interface OfferDisplayableProps {
  want_cover?: boolean;
  want_text?: boolean;
  want_other?: boolean;
  want_other_value?: string;
  planned_price?: number | null;
  planned_price_type?: string;
}

/**
 * OfferとOfferHistoryで共有される表示メソッド
 */
export const OfferDisplayable = {
  /**
   * データ2次使用希望の表示値を返す
   * @param t - 翻訳関数
   * @returns カンマ区切りの文字列
   */
  showWantDesign(this: OfferDisplayableProps, t: (key: string) => string): string {
    const tmp: string[] = [];

    if (this.want_cover) {
      tmp.push(t("components/offerForm:wantCover"));
    }
    if (this.want_text) {
      tmp.push(t("components/offerForm:wantText"));
    }
    if (this.want_other) {
      let other = t("components/offerForm:wantOther");
      if (this.want_other_value) {
        other += ` (${this.want_other_value})`;
      }
      tmp.push(other);
    }
    
    return tmp.join(", ");
  },

  /**
   * 予定価格の表示値を返す
   * @param t - 翻訳関数
   * @param sepWithComma - 数値をカンマ区切り文字列に変換する関数
   * @returns フォーマットされた価格文字列、またはnull
   */
  showPlannedPrice(
    this: OfferDisplayableProps,
    t: (key: string) => string,
    sepWithComma: (num: number) => string
  ): string | null {
    if (this.planned_price == null) {
      return null;
    }

    const currency = this.planned_price_type
      ? t(`components/offerForm:currencyTypes.${this.planned_price_type}`)
      : "";

    return `${sepWithComma(this.planned_price)} ${currency}`.trim();
  },
};

